import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../utils';
import PropTypes from 'prop-types';
import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';
import { NewsCard } from '../components';
import '../assets/styles/pages/_news-listing.scss';
import { startLoader } from '../components/common/Loader';
import { useDate as getDate } from '../hooks';
import Pagination from 'react-js-pagination';
import { useHistory } from 'react-router';

const NewsListing = ({ getNewsListing, ...props }) => {
  const [news, setNews] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const history = useHistory();

  useEffect(() => {
    const getNewsData = (currentPage) => {
      getNewsListing(currentPage, 10).then((response) => {
        setTotalPages(response.res.total);
        setNews(response.res.data);
      });
    };
    getNewsData(activePage);
  }, [activePage, getNewsListing]);

  useEffect(() => {
    props.getMeta('News');
    startLoader();
    const urlPage = new URLSearchParams(props.location.search).get('page');
    urlPage && setActivePage(+urlPage);
  }, [props.location.search]);

  const handleChangePage = (pageNumber) => {
    if (pageNumber !== activePage) {
      startLoader();
      history.push({ search: `?page=${pageNumber}` });
      setActivePage(pageNumber);
    }
  };

  const metaData = props.metaData?.res;

  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <div className='news__listing'>
        <Link to='/' className='banner-logo'>
          <img src='/media/images/InClassicaColorLogo.png' alt='logo' />
        </Link>
        <h1 className='news__listing__title'>LATEST NEWS</h1>

        {news && news.length
          ? news.map((n) => {
              const d = getDate(n.date);
              return (
                <NewsCard
                  key={n.id}
                  url={`/news/${n.url}`}
                  date={`${d.day} ${d.month} <br /> ${d.year}`}
                  title={n.title}
                  subtitle={n.subtitle}
                  poster={n.poster}
                  external={n.external_url}
                  isFeatured={!!n.featured}
                />
              );
            })
          : ''}
        <div className='newsPagination'>
          <Pagination
            hideFirstLastPages
            hideNavigation
            activePage={activePage}
            itemsCountPerPage={10}
            totalItemsCount={totalPages}
            pageRangeDisplayed={5}
            onChange={(e) => handleChangePage(e)}
          />
        </div>
      </div>
    </>
  );
};

NewsListing.propTypes = {
  getNewsListing: PropTypes.func,
};

function mapState (state) {
  return {
    news: state.getNewsListing,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getNewsListing: userActions.getNewsListing,
  getMeta: userActions.getMetaData,
};

NewsListing.fetchMeta = () => actionCreators.getMeta('News');

export default connect(mapState, actionCreators)(NewsListing);
